import React from 'react';
import BrandLogo from '../components/BrandLogo';
import LandingSplit from '../components/LandingSplit';
import { usePageTracking } from '../hooks/usePageTracking';

function Home() {
  usePageTracking('home');

  return (
    <div className="home-page">
      <BrandLogo />
      <LandingSplit />
    </div>
  );
}

export default Home;
